import { AI_SERVICE_BASE_URL } from '../config';

export const getChatEndpoint = (path = '') => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${AI_SERVICE_BASE_URL}${normalizedPath}`;
};
